import { mutatorAction } from 'satcheljs';
import type {
    ResultItemDetailValue,
    SonoraResultDetailItemsType,
    SonoraViewState,
} from 'owa-editor-sonora-types';

export const showDetailsMenu = mutatorAction('showDetailsMenu', (viewState: SonoraViewState) => {
    viewState.isDetailsMenuOpen = true;
});

export const hideDetailsMenu = mutatorAction('hideDetailsMenu', (viewState: SonoraViewState) => {
    viewState.isDetailsMenuOpen = false;
});

export const setSonoraResultItemDetails = mutatorAction(
    'setSonoraResultItemDetails',
    (
        viewState: SonoraViewState,
        detailValues: Map<SonoraResultDetailItemsType, ResultItemDetailValue[]>,
        targetRef: HTMLElement,
        resultItemOnClickAction: (itemDetail: string) => void
    ) => {
        viewState.sonoraResultItemDetails.targetRef = targetRef;
        viewState.sonoraResultItemDetails.resultItemOnClickAction = resultItemOnClickAction;
        detailValues.forEach((value, key) => {
            viewState.sonoraResultItemDetails.detailValues.set(key, value);
        });
    }
);

export const clearSonoraResultItemDetails = mutatorAction(
    'clearSonoraResultItemDetails',
    (viewState: SonoraViewState) => {
        viewState.sonoraResultItemDetails.targetRef = undefined;
        viewState.sonoraResultItemDetails.resultItemOnClickAction = undefined;
        viewState.sonoraResultItemDetails.detailValues.clear();
    }
);

export const setSonoraResultItemOnClickAction = mutatorAction(
    'setSonoraResultItemOnClickAction',
    (viewState: SonoraViewState, clickAction: (itemDetail: string) => void) => {
        viewState.sonoraResultItemOnClickAction = clickAction;
    }
);
